import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MensagensService {

  constructor(
    private snackBar: MatSnackBar
  ) { }

  sucesso(mensagem?: string): void {
    if (mensagem) {
      this.snackBar.open(mensagem, 'Ok', { duration: 5000 });
    }
  }

  erro(mensagem?: string): void {
    if (!mensagem) {
      this.snackBar.open('Ops, ocorreu um erro inesperado', 'Ok', { duration: 5000 });
    } else {
      this.snackBar.open(mensagem, 'Ok', { duration: 5000 });
    }
  }

}
